import React from "react";
import { Link } from "react-router-dom";
import "./Inicio.css";

function Inicio() {
  return <div className="test">
    <div className="inicio-hero">
      {/* You can place optional overlay text or buttons here */}
    </div>
  </div>;
}

export default Inicio;
